module.exports = __webpack_public_path__ + "static/media/logoDark.16a6d774.svg";